import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import Pagination from '../../components/common/Pagination'
import AuditReportTable from '../../components/AuditReports/AuditReportTable'
import AuditReportFilter from '../../components/AuditReports/AuditReportFilter'

import { fetchGlobalReports } from '../../actions/reports'
import { asQueryObject, asQueryString } from '../../const/helper'

class AuditReportList extends React.Component {
  componentWillReceiveProps (nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.props.fetchGlobalReports(nextProps.location.search, this.props.accessToken)
    }
  }

  componentWillMount () {
    this.props.fetchGlobalReports(this.props.location.search, this.props.accessToken)
  }

  handleFilter (filter) {
    delete filter.page
    if (filter.customer) {
      filter.customer = filter.customer.value.id
    }
    return this.props.push(`/audit-reports?${asQueryString(filter)}`)
  }

  render () {
    const { reports, pagination, location, isCustomer } = this.props

    return (
      <div className='content'>
        <div className='main-header'>
          <h2>Audit Reports </h2>
          <em className='hide'>normal sidebar with minified mode by default</em>
        </div>
        <div className='main-content'>
          <div className='row'>
            <div className='col-md-8'>
              { reports
                ? <div>
                  <AuditReportFilter
                    onSubmit={this.handleFilter.bind(this)}
                    initialValues={asQueryObject(location.search)}
                    isCustomer={isCustomer}
                    customerAPI={{
                      url: process.env.REACT_APP_BASE_API + '/customers',
                      accessToken: this.props.accessToken,
                    }}
                  />
                  <p>Total count : {pagination.totalCount} {pagination.totalCount > 1 ? 'items' : 'item'}</p>
                  <AuditReportTable reports={reports} />
                </div>
                : <div>loading</div>
              }
              <Pagination pagination={pagination} base='/audit-reports' params={asQueryObject(location.search)} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    reports: state.reports.globalReportList.data,
    pagination: state.reports.globalReportList.pagination,
    accessToken: state.auth.user.access.access_token,
    isCustomer: state.auth.user.data.role.includes('Customer')
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    fetchGlobalReports: (params, key) => dispatch(fetchGlobalReports(params, key)),
    push: (to) => dispatch(push(to))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuditReportList)
